<ng-container [ngSwitch]="display">
  <span class="text-base uppercase lg:normal-case" *ngSwitchCase="IDisplay.Currency" (click)="openOffCanvas()">
    {{ currency?.name }} {{ currency?.parameters?.symbol?.value }}
  </span>
  <span class="text-base uppercase lg:normal-case" *ngSwitchCase="IDisplay.CurrencySymbol" (click)="openOffCanvas()">
    {{ currency?.parameters?.symbol?.value }}
  </span>
  <span class="text-base uppercase lg:normal-case" *ngSwitchCase="IDisplay.Language" (click)="openOffCanvas()">
    {{ language?.name }}
  </span>
  <span *ngSwitchCase="IDisplay.Both" (click)="openOffCanvas()" class="text-base flex items-center uppercase lg:normal-case">
    {{ language?.name }} | {{ currency?.parameters?.symbol?.value }}
    <i class="fa-solid fa-chevron-down pl-2 text-xs"></i>
  </span>
</ng-container>

<vg-offcanvas #offcanvas>
  <vg-offcanvas-header>
    <h5 i18n="@@currency.languages_currencies">Languages & Currencies</h5>
  </vg-offcanvas-header>
  <vg-offcanvas-body>
    <div class="grid grid-cols-2 gap-4">
      <vl-list>
        <vl-list-item class="border-b border-b-primary">
          <span class="text-primary text-base" i18n="@@currency.language">Language</span>
        </vl-list-item>

        <vl-list-item class="text-sm text-dark hover:text-primary" *ngFor="let l of languages; let isFirst = first" [ngClass]="{'font-mediumum !text-primary': l.name == language.name, '!pt-0': !isFirst}">
          <a [href]="l.url">{{ l.name }}</a>
        </vl-list-item>
      </vl-list>
      <vl-list>
        <vl-list-item class="border-b border-b-primary">
          <span class="text-primary text-base">Currency</span>
        </vl-list-item>

        <vl-list-item class="text-sm text-dark hover:text-primary" *ngFor="let c of currencies; let isFirst = first" (click)="onCurrencyChange(c)" [ngClass]="{'font-mediumum !text-primary': c._id == currency?._id, '!pt-0': !isFirst}">
          {{c?.parameters?.code?.value}} {{c?.parameters?.symbol?.value}}
        </vl-list-item>
      </vl-list>
    </div>
  </vg-offcanvas-body>
</vg-offcanvas>